import ControllerBase from 'global/js/ControllerBase';
import UIkit from 'uikit';
global ? (global['UIkit'] = UIkit) : undefined;

export default class ControllerOffcanvas extends ControllerBase {

	private closeButton: HTMLAnchorElement;

	constructor(element: HTMLElement) {
		super(element);
		this.closeButton = this.$element.querySelector('.js-close-offcanvas-button') as HTMLAnchorElement;
		this.closeButton.addEventListener('click', e => this.closeOffcanvas(e))
		this.checkOffcanvasOpenStatus();
	}

	private checkOffcanvasOpenStatus(): void {
		const offcanvasRefs = document.querySelectorAll('[uk-offcanvas]') as NodeListOf<HTMLDivElement>;
		const indexCanvasToBeOpened = [...offcanvasRefs].findIndex((ref) => ref.dataset.openOnLoad === 'true');
		if (indexCanvasToBeOpened >= 0) {
			UIkit.offcanvas(offcanvasRefs[indexCanvasToBeOpened]).show();
		}
	}

	private closeOffcanvas(e: MouseEvent | PointerEvent) {
		e.preventDefault()
		const variant = `#nav-offcanvas--${this.closeButton.dataset.variant}`
		variant && UIkit.offcanvas(variant).hide()
	}

}
